<template>
  <div :class="['filters-control']" v-if="index !== null">
    <table-layout full-width y-align="middle" :class="['my-4']" :title="lang.mixBlendMode">
      <row>
        <cell :class="['icon-cell']" x-align="center">
          <icon name="pot-mix" />
        </cell>
        <cell>
          <select v-model="mixBlendMode" @change="applyFilters">
            <option v-for="(mode, index) in mixBlendModes" :value="mode" :key="index" v-html="firstLetterCapital(mode)" />
          </select>
        </cell>
      </row>
    </table-layout>
    <ul :class="['filters-list', 'flex', 'equal-width', 'flex-wrap']">
      <li
        v-for="(settings, name) in image.filters"
        :key="name"
        :class="['py-2']"
        v-if="settings.render">
        <label :title="firstLetterCapital(name)">
          <table-layout full-width y-align="middle">
            <row>
              <cell :class="['icon-cell']" x-align="center">
                <icon :name="settings.icon" />
              </cell>
              <cell>
                <input
                  :type="settings.type"
                  :title="settings.value"
                  @input="applyFilters"
                  :min="settings.min"
                  :max="settings.max"
                  v-model="settings.value" />
              </cell>
            </row>
          </table-layout>
        </label>
      </li>
    </ul>
  </div>
</template>
<script>
import events from '../helpers/events'
import lang from '../helpers/lang'
import methods from '../helpers/methods'
import mixBlendModes from '../helpers/mix-blend-modes'

export default {
  name: 'FiltersControl',
  mixins: [
    methods
  ],
  data () {
    return {
      lang,
      mixBlendModes,
      mixBlendMode: 'normal',
      image: null,
      index: null
    }
  },
  watch: {
    index () {
      this.mixBlendMode = this.image.mixBlendMode
    }
  },
  created () {
    this.bind()
  },
  methods: {
    /**
     * Bind to custom events, emitted by components
     * @method bind
     * @return {void}
     */
    bind () {
      this.$root.$on(events.imageSelect, (data) => {
        this.index = data.selectedLayer
        this.image = data.selectedImage
      })
    },
    /**
     * Create filters array and CSS filters string
     * @method applyFilters
     * @return {void}
     */
    applyFilters () {
      let filtersString = []
      const filters = this.image.filters
      Object.keys(filters).forEach(filter => {
        filters[filter].value = parseInt(filters[filter].value, 10)
        filtersString.push(`${filter}(${filters[filter].value}${filters[filter].unit})`)
      })
      filtersString = filtersString.join(' ')
      this.$root.$emit(events.filtersApply, {
        filtersString,
        filters,
        mixBlendMode: this.mixBlendMode
      })
    }
  }
}
</script>
<style>
.filters-control .filters-list
{
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/filters-control.vue